const independentWeighUp = () => import("./views/independent_weigh_up.vue");

import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/independent_weigh_up_tasting",
      component: independentWeighUp,
      name: "Independent weigh up tasting",
      meta: {
        groupName: "QC & QA",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
